import { Boxes } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BoxesIcon = createLucideIcon(Boxes);
